import echoClient from "./Echo.Client"
import type { EchoEndpointBuilder } from "./Echo.Slice"
import { EchoTag } from "./api/util/EchoTag"

const spireEndpoints = (build: EchoEndpointBuilder) => ({
	echoSpireIntegrationGetAllRecords: build.query({
		queryFn: (_: void) => echoClient.spire.records(),
		providesTags: [EchoTag.Tenant, EchoTag.SpireIntegration]
	}),
	echoSpireIntegrationClearAllRecords: build.mutation({
		queryFn: (_: void) => echoClient.spire.clear(),
		invalidatesTags: [EchoTag.SpireIntegration]
	}),
	echoSpireIntegrationAddRecords: build.mutation({
		queryFn: echoClient.spire.add,
		invalidatesTags: [EchoTag.SpireIntegration]
	})
})

export default spireEndpoints
